import React, { type ReactElement } from 'react';

export function instantiateComponent(
  component: unknown,
  props: Record<string, unknown>,
): ReactElement<unknown> | ReactElement<unknown>[] | null {
  if (!component) {
    return null;
  } else if (Array.isArray(component)) {
    // @ts-expect-error
    return component.map((c, key) => instantiateComponent(c, { ...props, key }));
  } else if (React.isValidElement(component)) {
    return React.cloneElement(component, props);
  } else if (
    typeof component === 'function' &&
    (component as { prototype?: { isReactComponent?: unknown } }).prototype?.isReactComponent
  ) {
    return React.createElement(component as React.ElementType, props) as ReactElement<unknown>;
  } else if (typeof component === 'function') {
    return React.createElement(component as React.ElementType, props) as ReactElement<unknown>;
  } else if (typeof component === 'object' && component !== null && 'render' in component) {
    return React.createElement(component as React.ElementType, props) as ReactElement<unknown>;
  } else {
    return component as ReactElement<unknown>;
  }
}
